import { isAllPartiesList, type PartyListSource } from '../../../lib/ballot-parties-api';

// Quiet hint that the list is every active party, not this election's ballot — either
// none is configured (resolver 'fallback') or the resolver couldn't be reached.
export const AllPartiesNote = ({ source }: { source: PartyListSource }) =>
	isAllPartiesList(source) ? (
		<p
			className='pv-note'
			role='note'
		>
			Showing all active parties — no ballot set for this election.
		</p>
	) : null;
